/*
 * Name: responsiveTable
 * 
 * Original Author: Brad Barton
 * Built for: Lexmark International
 * Date Created: 11/15/2013
 * 
 * Refactored for current LXCore structure
*/

(function ($) {
  'use strict';

  jQuery.fn.extend({
    lxk_responsiveTable: function () {

      var ResponsiveTable = function (element, options) {
        this.element = element;
        this.options = options;
        this.metadata = $(element).data('tbl-responsive-options');
      };

      ResponsiveTable.prototype = {
        defaults: {
          RESPONSIVE_TABLE_CLASS: 'tbl-responsive'
        },

        events: {
          init: 'lxk.responsiveTable.init'
        },

        setSettings: function () {
          var _ = this;

          // merge defaults and other settings/options
          _.settings = $.extend({}, _.defaults, _.options, _.metadata);
          _.settings.error = '';

          // cache items for best performance
          _.$tblElement = $(_.element);
        },

        addResponsiveClass: function () {
          var _ = this;
          var tblClass = _.settings.RESPONSIVE_TABLE_CLASS;

          if (_.$tblElement.hasClass(tblClass) != true) {
            _.$tblElement.addClass(tblClass);
          }
        },

        getHeadings: function () {
          var _ = this;
          var headings = _.$tblElement.find("thead th").map(function () {
            return $(this).text();
          });
          return headings;
        },

        setHeadings: function () {
          var _ = this;
          var headings = _.getHeadings();

          _.$tblElement.find("tbody tr").each(function () {
            $(this).find("td").each(function(i) {
              $(this).attr("data-heading", headings[i]);
            });
          });
        },

        init: function () {
          var _ = this;

          _.setSettings();

          // execute init event
          _.$tblElement.trigger($.Event(_.events.init));

          // add the responsive class to the table
          _.addResponsiveClass();

          // set headings on each td element of the table
          _.setHeadings();
        }
      };

      ResponsiveTable.defaults = ResponsiveTable.prototype.defaults;

      $.fn.responsiveTable = function (options) {
        return this.each(function (i, element) {
          new ResponsiveTable(element, options).init();
        });
      };

      window.ResponsiveTable = ResponsiveTable;

      $(window).on('load', function () {
        $('table:not(.dataTable)').responsiveTable();
      });
    }
  });
  jQuery(document).lxk_responsiveTable();
})(jQuery);
